import { createSlice } from "@reduxjs/toolkit";


const companySlice = createSlice({
    name: "company",
    initialState: {
        data: {
            id: 1,
            companyId:1,
            isChangeCompanyModalOpen: false,
        },
    },
    reducers: {
        setCompany: (state, action) => {
            state.data = action.payload
        }
    },
});

export const { setCompany } = companySlice.actions;
export default companySlice.reducer;
